import React from 'react';

export interface TableColumnProps {
    columnKey: string;
    header?: string;
    width?: string; // example usage: '220px', '30%', 'auto'
    visible?: boolean;
    showHeaderOnWrap?: boolean;
    actionColumn?: boolean;
    center?: boolean;
    /** Cuts text that doesn't fit to one line ending in "...", with the full text on hover, instead of scrolling. */
    abbreviateLongText?: boolean;
}

// Table reads each column's props itself (child.props), including showHeaderOnWrap, actionColumn, center and
// abbreviateLongText, and applies their defaults there; only the ones this renders are destructured here
export const TableColumn: React.FC<TableColumnProps> = ({ columnKey, header, width = 'auto', visible = true }) => {
    return (
        <>
            {visible && (
                <div
                    key={columnKey}
                    className='table-column'
                    style={{ flexBasis: width }}
                >
                    {header}
                </div>
            )}
        </>
    );
};
